"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetOmniBarService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const biome_ai_web_1 = require("@branch-ts/biome-ai-web");
const practice_omni_web_1 = require("@branch-ts/practice-omni-web");
const practice_idps_web_1 = require("@branch-ts/practice-idps-web");
const probe_consensus_1 = require("@branch-ts/probe-consensus");
const service_VersetSingular_1 = require("./service.VersetSingular");
const verset_consensus_1 = require("@project/verset_consensus");
const feature_1 = require("./service.Verset/feature");
const service_VersetIC_1 = require("./service.VersetIC");
const service_VersetProbe_1 = require("./service.VersetProbe");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
const service_VersetTheme_1 = require("./service.VersetTheme");
const service_VersetVerse_1 = require("./service.VersetVerse");
const subscriptionRank_1 = require("./userProfile/subscriptionRank");
let VersetOmniBarService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetOmniBarService = class {
        static { _classThis = this; }
        constructor() {
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                VersetICService: service_VersetIC_1.VersetICService,
                VersetProbeService: service_VersetProbe_1.VersetProbeService,
                VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService,
                VersetThemeService: service_VersetTheme_1.VersetThemeService,
                VersetVerseService: service_VersetVerse_1.VersetVerseService,
                VersetSingularService: service_VersetSingular_1.VersetSingularService,
            });
            this.icOmniSupport = null;
            this.verseOmniSupport = null;
        }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetOmniBarService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        async initialize() {
            const omniBar = new practice_omni_web_1.OmniBar(this.deps.VersetSingularService.singular.renderContext);
            omniBar.enable();
            this.omniBar = omniBar;
            console.log("DebugICWire: VersetOmniBarService.initialize omni-bar-ready");
            (0, feature_1.OmniProductQuickIconsFeature)({
                omniBar,
            });
            omniBar.extraWidgets.register({
                id: "subscription-tier",
                widget: new subscriptionRank_1.SubscriptionRank(this.deps.VersetRequireLoginService.server),
            });
            const verse = this.deps.VersetVerseService.main;
            if (!verse) {
                throw new Error("Main Verse context is unavailable");
            }
            this.verseOmniSupport = new biome_ai_web_1.VerseOmniSupport(omniBar, {
                verse,
                title: "Projects",
            });
            const probeSessionManager = this.deps.VersetProbeService.probeSessionManager;
            this.probeOmniSupport = new biome_ai_web_1.ProbeOmniSupport(omniBar, {
                probeSessionManager,
                title: probe_consensus_1.ProbeProtocol.ProductName.probe,
            });
            console.log("DebugICWire: VersetOmniBarService.initialize probe-support-ready");
            const intelligenceCenter = this.deps.VersetICService.intelligenceCenter;
            console.log("DebugICWire: VersetOmniBarService.initialize ic-check", {
                hasIntelligenceCenter: !!intelligenceCenter,
                scopeURI: this.deps.VersetICService.scopeURI,
            });
            if (intelligenceCenter) {
                this.icOmniSupport = new biome_ai_web_1.ICOmniSupport(omniBar, {
                    intelligenceCenter,
                    editorKind: this.deps.VersetRequireLoginService.agreement.particulars.versetWebapp.idps.editorKind,
                    title: verset_consensus_1.VersetProtocol.ProductName.intelligenceCenterPanel,
                    makePanel: (option) => new practice_idps_web_1.IntelligenceCenterPanel({
                        ...option,
                        tabListLabel: verset_consensus_1.VersetProtocol.ProductName.intelligenceCenterPanel,
                        spotsTabLabel: verset_consensus_1.VersetProtocol.ProductName.spot,
                        objectivesTabLabel: `${verset_consensus_1.VersetProtocol.ProductName.objective}s`,
                        objectivesEmptyState: {
                            message: "No objectives yet.",
                            hint: "Hover over an entry and press O to mark it as an objective.",
                            documentation: {
                                label: "Learn about objectives",
                                href: "https://doc.verset.io/features/objectives",
                            },
                        },
                        spotsEmptyState: {
                            message: "No active work or results awaiting review.",
                            hint: "Hover over an entry and press Shift+1 to start a chat. It appears here while running or awaiting review.",
                            documentation: {
                                label: "Learn about Work Center",
                                href: "https://doc.verset.io/glossaries/ai#work-center",
                            },
                        },
                    }),
                });
                console.log("DebugICWire: VersetOmniBarService.initialize ic-support-ready");
            }
            else {
                console.log("DebugICWire: VersetOmniBarService.initialize ic-support-skipped");
            }
        }
    };
    return VersetOmniBarService = _classThis;
})();
exports.VersetOmniBarService = VersetOmniBarService;
